<div class="container-fluid h-100 bg-light-custom">
  <div class="row bg-blu justify-content-center">
    <div class="col-12 center text-center">
      <img [src]="logo" width="192" height="50" alt="Geo4B" />
    </div>
  </div>

  <div
    class="row d-flex align-items-center height-custom justify-content-center"
  >
    <div class="col-4">
      <div class="login-wrapper p-3 my-auto bg-white-trasparent rounded shadow">
        <h4 class="text-center mt-2 txt-bg-blu">Accedi al Portale</h4>

        <!-- ------------------------------------------------------------------------------- -->

        <!--  Microsoft Azure AD SSO -->

        <form #f="ngForm" class="mx-2 mt-2 mb-2 txt-bg-blu">
          <div class="form-group text-center">
            <button
              type="button"
              class="btn bg-blu mt-4 txt-white w-35 d-flex align-items-center mx-auto microsoft-login-btn"
              (click)="onLogin()"
            >
              <span class="icon-container">
                <img src="./assets/img/ms-pictogram.svg" alt="Pictogram" />
              </span>

              <span class="flex-grow-1 text-center">Accedi con Microsoft</span>
            </button>

            <!-- <button
              type="button"
              class="btn bg-blu mt-4 txt-white w-30 d-flex align-items-center mx-auto"
              (click)="onLogin()"
            >
              <span class="icon-container"
                ><fa-icon [icon]="faUserIcon"></fa-icon
              ></span>
              <span class="flex-grow-1 text-center">Login</span>
            </button> -->
          </div>
        </form>

        <!-- ------------------------------------------------------------------------------- -->
      </div>
      <!-- <div class="login-wrapper p-3 my-auto bg-white rounded shadow" id="wrench">

            <h4 class="text-center mt-2 txt-bg-blu icon-wrench">
               <fa-icon aria-hidden=" true" [icon]="faWrench"></fa-icon>
            </h4>
            <p class="unavailable text-center">INTERVENTO TECNICO SUL SISTEMA</p>

            <p class="update-app">
               Causa intervento tecnico di manutenzione potrebbero essere riscontrate delle anomalie nel funzionamento dell'applicazione nella giornata di oggi.
            </p>
         </div> -->
      <div
        *ngIf="isINWIT"
        class="login-wrapper p-3 my-auto bg-white rounded shadow"
        id="wrench"
      >
        <h4 class="text-center mt-2 txt-bg-blu icon-wrench">
          <p class="unavailable text-center">
            <fa-icon aria-hidden=" true" [icon]="faWrench"></fa-icon> ATTENZIONE
          </p>
        </h4>
        <p class="update-app">
          <small>
            Il portale Atlante, nonostante le ultime restrizioni dell'Agenzia
            delle Entrate, è comunque funzionante seppur con qualche
            limitazione. E' possibile fare analisi che verranno eseguite con
            tempistiche variabili. Si consiglia di verificare l'esecuzione delle
            stesse controllando periodicamente i risultati prima di rieseguirne
            di nuove.
          </small>
        </p>
        <p class="align-left">
          <small>Data aggiornamento: 31/05/2022</small>
        </p>
      </div>
    </div>
  </div>
</div>
